export class Verify {
  code?: string;
  email?: string;
  targetTemplate?: string;
}
  